export const buildTime = '2026-06-10 14:22:17 UTC';
